import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// import { Dialog } from "./components/index.js";
import { Modal } from "react-responsive-modal";
import "./PPUConsentScreen.scss";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { AppState } from "webapp/enums/AppState";
import { useEffect } from "react";
import { devLog } from "utils/devLog";

export default function PPUConsentScreen(props) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(true);
  // const [isOpen, setIsOpen] = useState(true);

  // const [firstName] = useState(props.currState.FirstName || "");
  // const [lastName] = useState(props.LastName || "");
  // const [fullNameProps] = useState(props.FirstName + " " + props.LastName || "");

  useEffect(() => {
    devLog("PPUConsentScreen currState", props.currState);
  }, [props.currState]);

  const onUserBack = () => {
    setIsOpen(false);
    // CIBC member-info flow passes onNo to dismiss the modal
    if (typeof props.onNo === "function") {
      props.onNo();
      return;
    }
    props.context.setState(
      {
        PPUReason: props.PPUReason,
      },
      () => {},
    );
    if (typeof props.onUserBack === "function") {
      devLog("onUserBack");
      props.onUserBack();
    }
  };

  const onSubmit = (e) => {
    // CIBC "add new driver" flow passes onYes to accept and continue with account
    if (typeof props.onYes === "function") {
      setIsOpen(false);
      props.onYes();
      return;
    }

    // No member search result / MNF: go to vehicle info without account/contact refs
    setIsOpen(false);
    devLog("PPUConsent Accept — navigate to ConfirmVehicle", {
      PPUReason: props.PPUReason,
      accountRef: props.context?.state?.accountRef,
    });
    if (props.PPUReason === "EXPIRED") {
      props.context.setState(
        {
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.context.saveWebAppState === "function") {
            props.context.saveWebAppState(props.context);
          }
        },
      );
    } else {
      props.context.setState(
        {
          accountRef: null,
          memberRef: null,
          contactRef: null,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.context.saveWebAppState === "function") {
            props.context.saveWebAppState(props.context);
          }
        },
      );
    }
  };

  const onClose = () => {
    setIsOpen(false);
    if (typeof props.onNo === "function") {
      props.onNo();
    }
  };

  return (
    <>
      <Modal
        classNames={{ modal: "PPUConsentScreen" }}
        open={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        showCloseIcon={false}
      >
        <h2 style={{ marginTop: 30 }}>{t("description.TVLAccidentQuestionHeader")}</h2>
        {/* <img className="img" src={props.logo} alt="trx now logo" /> */}
        {props.partnerCode === "CIBC" && <div class="message">{t("description.OOPConsentMsgCIBC")}</div>}
        {props.partnerCode === "LMC" && <div class="message">{t("description.OOPConsentMsgLMC")}</div>}
        {props.partnerCode === "APCO" && <div class="message">{t("description.OOPConsentMsgCIBC")}</div>}
        {props.PPUReason === "MNF" && <div class="message">{t("description.MNFInformMsg")}</div>}
        {props.PPUReason === "EXPIRED" && <div class="message">{t("description.OOPConsentMsgExpired")}</div>}

        {/* if PPUReason is MNF or EXPIRED, show the continue button */}
        {/* For CIBC & LMC OOP Consent */}
        {props.PPUReason === "MNF" || props.PPUReason === "EXPIRED" ? (
          <div className="footerContainer">
            <div type="hidden" onClick={onUserBack} className="footer">
              <span>{t("description.Search")}</span>
            </div>
            <div type="hidden" onClick={onSubmit} className="footer">
              <span>{t("description.ConfirmServicesContinue")}</span>
            </div>
          </div>
        ) : (
          <div className="footerContainer">
            <div type="hidden" onClick={onUserBack} className="footer">
              <span>{t("description.Deny")}</span>
            </div>
            <div type="hidden" onClick={onSubmit} className="footer">
              <span>{t("description.Accept")}</span>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
}
